package xim.poc.game.configuration.v0.tactics

import xim.poc.game.ActorState
import xim.poc.game.configuration.SkillApplierHelper
import xim.poc.game.configuration.constants.*
import xim.poc.game.configuration.v0.tactics.behaviors.TacticsBehaviorController
import xim.poc.game.configuration.v0.tactics.behaviors.TacticsSkillQuery
import xim.poc.game.event.Event
import kotlin.math.pow

class TacticsFenrirBehavior(actorState: ActorState): TacticsBehaviorController(actorState) {

    private val skillGroupings = listOf(
        listOf(mskillMoonlitCharge_575, mskillCrescentFang_576, mskillEclipseBite_580),
        listOf(mskillLunarCry_577, mskillLunarRoar_579),
        listOf(mskillEclipticGrowl_578, mskillEclipticHowl_581),
        listOf(mskillLunarBay_3295, mskillImpact_3296),
    )

    private var selector = 0

    override fun onBehaviorInitialized(): List<Event> {
        actorState.getUnit().addInstinct(TacticsInstincts.pass, 1)
        actorState.getUnit().addInstinct(TacticsInstincts.resistAll, 20)
        actorState.getUnit().addInstinct(TacticsInstincts.resistParalysis, 100)
        return emptyList()
    }

    override fun getSelectableSkills(): List<SkillId> {
        return if (wantsToAstralFlow() && isDisplayCharging()) {
            listOf(mskillHowlingMoon_582)
        } else {
            skillGroupings[selector]
        }
    }

    override fun estimateSkillValue(query: TacticsSkillQuery): Float {
        val multiplier = if (selector == 1 || selector == 2) {
            1f / 10f.pow(query.destinationPosition.distance(query.originalPosition))
        } else {
            1f
        }

        return multiplier * super.estimateSkillValue(query)
    }

    override fun onSkillExecutedScoped(primaryTargetContext: SkillApplierHelper.TargetEvaluatorContext): List<Event> {
        if (primaryTargetContext.skill == mskillHowlingMoon_582) {
            endCharging()
        } else {
            selector = (selector + 1) % skillGroupings.size
        }

        if (wantsToAstralFlow()) { displayCharging(primaryTargetContext.context) }

        return emptyList()
    }

    private fun wantsToAstralFlow(): Boolean {
        return !hasUsedSkill(mskillHowlingMoon_582) && actorState.getHpp() < 0.5f && selector != 1
    }

}